import { jsx } from 'react/jsx-runtime';
import { Primitive } from '@radix-ui/react-primitive';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { labelSlot } from './slot.vanilla.mjs';

const LabelSlot = forwardRef(
  ({ className: classNameFromProps, ...props }, forwardedRef) => {
    const className = classNames(labelSlot, classNameFromProps);
    return /* @__PURE__ */ jsx(
      Primitive.div,
      {
        "data-scope": "label",
        "data-part": "slot",
        className,
        ref: forwardedRef,
        ...props
      }
    );
  }
);

export { LabelSlot };
//# sourceMappingURL=Slot.mjs.map
